import React from "react";
import { SiteLayout } from "../components/SiteLayout";

export interface InteractivesLayoutProps {
  children: React.ReactNode;
}

export function InteractivesLayout({ children }: InteractivesLayoutProps) {
  return <SiteLayout>{children}</SiteLayout>;
}
